/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react'
import { Link, withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import get from 'lodash/get'

import Button from './../Button'
import SVG from './../SVG'
import { getSVG } from './../../helpers/util'
import routes from './../../constants/routes'

import './FixedSidebar.scss'
import { convertIn12HoursFormat } from '../../helpers/dateUtil'
import isEmpty from 'lodash/isEmpty'
import { crewCardValue } from '../../constants'
var pjson = require('../../../package.json')

const dashboardSvg = getSVG('dashboard')
const masterBoardingSVG = getSVG('masterBoarding')
const guestSvg = getSVG('guest')
const crewSvg = getSVG('crew')
const visitorsSvg = getSVG('visitors')
const reportsSvg = getSVG('reports')
const messageSVG = getSVG('message')
const cabinSVG = getSVG('cabin')
const settingsSVG = getSVG('settings')
const ipmSvg = getSVG('ipm')
const boardingSlotSVG = getSVG('boardingSlot')
const stateroomSVG = getSVG('stateroom')
const coordinateSVG = getSVG('coordinate')

const FixedSidebar = ({
  closeSidebar,
  match,
  voyageName,
  shipName,
  isShipMode,
  isShore,
  shouldShowBoardingSlots = false,
  shouldShowBoardingCount = false,
  shouldShowCrewList = false,
  shouldShowCrewRolesManagement = false,
  shouldShowGuestList = false,
  shouldShowIPMDutiesList = false,
  shouldShowVisitorList = false,
  shouldShowSettings = false,
  shouldShowAlertList = false,
  shouldShowMessageList = false,
  shouldShowReportList = false,
  shouldShowDashboard = false,
  shouldShowCbpDashboard = false,
  shouldShowStateroom = false,
  shouldShowCreateReservation = false,
  shouldShowMasterTemplate = false,
  shouldShowVoyagePortTerminals = false,
  settings,
  totalActiveSlotsCount,
  latestBoardingSlot
}) => {
  const getLatestBoardingSlot = slot => {
    if (isEmpty(slot)) return '--'
    if (get(settings, 'guest.isBoardingSlotLabel12HoursFormat', true)) {
      return `${convertIn12HoursFormat(
        get(slot, 'boardingSlotStartTime', '')
      )}-${convertIn12HoursFormat(get(slot, 'boardingSlotEndTime', ''))}`
    } else {
      return `${get(slot, 'boardingSlotStartTime', '').substring(0, 5)}-${get(
        slot,
        'boardingSlotEndTime',
        ''
      ).substring(0, 5)}`
    }
  }
  return (
    <div className="FixedSidebar">
      <div className="MenuItemContainer">
        <div className="MenuItem is-title">{shipName}</div>
        <div className="MenuItem is-title">{voyageName}</div>
      </div>
      {get(settings, 'sidebar.shouldShowAddReservationButton', false) &&
        shouldShowCreateReservation && (
          <Link to={`${match.path}/${routes.newReservation}`}>
            <div className="MenuItemContainer">
              <div className="MenuItem is-button">
                <Button className="is-primary is-fullwidth" onClick={() => {}}>
                  <FormattedMessage
                    id="FixedSidebar.newReservation"
                    defaultMessage="New Reservation"
                  />
                </Button>
              </div>
            </div>
          </Link>
        )}
      {shouldShowDashboard && (
        <div className="MenuItemContainer">
          <Link to={`${match.path}/${routes.dashboard}`}>
            <div
              className={`MenuItem ${
                window.location.href.includes(routes.dashboard) &&
                !window.location.href.includes(routes.cbpDashboard)
                  ? 'is-active'
                  : ''
              }`}
              onClick={closeSidebar}
              role="button"
              tabIndex={0}
              onKeyDown={e => {
                if (e.keyCode === 13) {
                  closeSidebar(e)
                }
              }}
            >
              <SVG height={20} width={20}>
                {dashboardSvg}
              </SVG>
              <div className="link-text">
                <FormattedMessage
                  id="FixedSidebar.dashboard"
                  defaultMessage="Dashboard"
                />
              </div>
            </div>
          </Link>
        </div>
      )}

      {get(settings, 'dashboard.shouldShowMasterTemplates', false) &&
        isShore &&
        shouldShowMasterTemplate && (
          <div className="MenuItemContainer">
            <Link to={`${match.path}/${routes.masterTemplates}`}>
              <div
                className={`MenuItem ${
                  window.location.href.includes(`/${routes.masterTemplates}`)
                    ? 'is-active'
                    : ''
                }`}
                onClick={closeSidebar}
                role="button"
                tabIndex={0}
                onKeyDown={e => {
                  if (e.keyCode === 13) {
                    closeSidebar(e)
                  }
                }}
              >
                <SVG height={20} width={20}>
                  {masterBoardingSVG}
                </SVG>
                <div className="link-text">
                  <FormattedMessage
                    id="FixedSidebar.masterTemplates"
                    defaultMessage="Master templates"
                  />
                </div>
              </div>
            </Link>
          </div>
        )}

      {(shouldShowBoardingSlots || shouldShowBoardingCount) &&
        get(settings, 'dashboard.shouldShowBoardingSlots', false) && (
          <div className="MenuItemContainer">
            <Link to={`${match.path}/${routes.boardingSlots}`}>
              <div
                className={`MenuItem ${
                  window.location.href.includes(`/${routes.boardingSlots}`) &&
                  !window.location.href.includes(`/${routes.reports}`)
                    ? 'is-active'
                    : ''
                }`}
                onClick={closeSidebar}
                role="button"
                tabIndex={0}
                onKeyDown={e => {
                  if (e.keyCode === 13) {
                    closeSidebar(e)
                  }
                }}
              >
                <SVG height={20} width={20}>
                  {boardingSlotSVG}
                </SVG>
                <div className="link-text">
                  <FormattedMessage
                    id="FixedSidebar.boardingSlots"
                    defaultMessage="Boarding Slots"
                  />
                  {isShipMode && latestBoardingSlot && (
                    <div className="recent-boarding-group">
                      {getLatestBoardingSlot(latestBoardingSlot)}
                      {totalActiveSlotsCount > 1 && (
                        <span>
                          {' + '} {totalActiveSlotsCount - 1}{' '}
                          <FormattedMessage
                            id="FixedSidebar.more"
                            defaultMessage="more"
                          />
                        </span>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </Link>
          </div>
        )}

      {shouldShowGuestList &&
        get(settings, 'sidebar.shouldShowGuestList', false) && (
          <div className="MenuItemContainer">
            <Link to={`${match.path}/${routes.guests}`}>
              <div
                className={`MenuItem ${
                  window.location.href.includes('guests') ? 'is-active' : ''
                }`}
                onClick={closeSidebar}
                role="button"
                tabIndex={0}
                onKeyDown={e => {
                  if (e.keyCode === 13) {
                    closeSidebar(e)
                  }
                }}
              >
                <SVG height={20} width={20}>
                  {guestSvg}
                </SVG>
                <div className="link-text">
                  <FormattedMessage
                    id="FixedSidebar.guest"
                    defaultMessage="Guest"
                  />
                </div>
              </div>
            </Link>
          </div>
        )}

      {shouldShowCrewList &&
        !isShore &&
        get(settings, 'sidebar.shouldShowCrewList', false) && (
          <div className="MenuItemContainer">
            <Link
              to={`${match.path}/${routes.crew}?checkedInStatus=${crewCardValue.checkedInStatus}`}
            >
              <div
                className={`MenuItem ${
                  window.location.href.includes('crew') &&
                  !window.location.href.includes(routes.crewRolesManagement)
                    ? 'is-active'
                    : ''
                }`}
                onClick={closeSidebar}
                role="button"
                tabIndex={0}
                onKeyDown={e => {
                  if (e.keyCode === 13) {
                    closeSidebar(e)
                  }
                }}
              >
                <SVG height={20} width={20}>
                  {crewSvg}
                </SVG>
                <div className="link-text">
                  <FormattedMessage
                    id="FixedSidebar.crew"
                    defaultMessage="Crew"
                  />
                </div>
              </div>
            </Link>
          </div>
        )}

      {shouldShowCrewRolesManagement && (
        <div className="MenuItemContainer">
          <Link to={`${match.path}/${routes.crewRolesManagement}`}>
            <div
              className={`MenuItem ${
                window.location.href.includes(routes.crewRolesManagement)
                  ? 'is-active'
                  : ''
              }`}
              onClick={closeSidebar}
            >
              <SVG height={20} width={20}>
                {settingsSVG}
              </SVG>
              <div className="link-text">
                <FormattedMessage
                  id="FixedSidebar.crewRolesManagement"
                  defaultMessage="Crew Roles Management"
                />
              </div>
            </div>
          </Link>
        </div>
      )}

      {shouldShowVisitorList &&
        get(settings, 'sidebar.shouldShowVisitorList', false) &&
        get(settings, 'sidebar.shouldShowVisitorListMenu', false) && (
          <div className="MenuItemContainer">
            <Link to={`${match.path}/${routes.visitors}`}>
              <div
                className={`MenuItem ${
                  window.location.href.includes('visitors') &&
                  !window.location.href.includes(routes.reports)
                    ? 'is-active'
                    : ''
                }`}
                onClick={closeSidebar}
                role="button"
                tabIndex={0}
                onKeyDown={e => {
                  if (e.keyCode === 13) {
                    closeSidebar(e)
                  }
                }}
              >
                <SVG height={20} width={20}>
                  {visitorsSvg}
                </SVG>
                <div className="link-text">
                  <FormattedMessage
                    id="FixedSidebar.visitor"
                    defaultMessage="Visitor"
                  />
                </div>
              </div>
            </Link>
          </div>
        )}

      {(shouldShowAlertList || shouldShowMessageList) && (
        <div className="MenuItemContainer">
          <Link to={`${match.path}/${routes.alertsAndMessages}`}>
            <div
              className={`MenuItem ${
                window.location.href.includes(routes.alertsAndMessages)
                  ? 'is-active'
                  : ''
              }`}
              onClick={closeSidebar}
              role="button"
              tabIndex={0}
              onKeyDown={e => {
                if (e.keyCode === 13) {
                  closeSidebar(e)
                }
              }}
            >
              <SVG height={20} width={20}>
                {messageSVG}
              </SVG>
              <div className="link-text">
                <FormattedMessage
                  id="FixedSidebar.alertsAndMessages"
                  defaultMessage="Alerts & Messages"
                />
              </div>
            </div>
          </Link>
        </div>
      )}

      {get(settings, 'sidebar.shouldShowStateroom', false) &&
        shouldShowStateroom && (
          <div className="MenuItemContainer">
            <Link to={`${match.path}/${routes.stateroom}`}>
              <div
                className={`MenuItem ${
                  window.location.href.includes(routes.stateroom)
                    ? 'is-active'
                    : ''
                }`}
                onClick={closeSidebar}
                role="button"
                tabIndex={0}
                onKeyDown={e => {
                  if (e.keyCode === 13) {
                    closeSidebar(e)
                  }
                }}
              >
                <SVG height={20} width={20}>
                  {stateroomSVG}
                </SVG>
                <div className="link-text">
                  <FormattedMessage
                    id="FixedSidebar.stateroom"
                    defaultMessage="Stateroom"
                  />
                </div>
              </div>
            </Link>
          </div>
        )}

      {get(settings, 'sidebar.shouldShowCabinList', false) && (
        <div className="MenuItemContainer">
          <Link to={`${match.path}/${routes.stateroom}`}>
            <div
              className={`MenuItem ${
                window.location.href.includes('cabins') ? 'is-active' : ''
              }`}
              onClick={closeSidebar}
              role="button"
              tabIndex={0}
              onKeyDown={e => {
                if (e.keyCode === 13) {
                  closeSidebar(e)
                }
              }}
            >
              <SVG height={20} width={20}>
                {cabinSVG}
              </SVG>
              <div className="link-text">
                <FormattedMessage
                  id="FixedSidebar.cabins"
                  defaultMessage="Cabins"
                />
              </div>
            </div>
          </Link>
        </div>
      )}

      {shouldShowIPMDutiesList &&
        get(settings, 'sidebar.shouldShowIpmDutiesList', false) &&
        !isShore && (
          <div className="MenuItemContainer">
            <Link to={`${match.path}/${routes.ipmLanding}`}>
              <div
                role="button"
                tabIndex={0}
                className={`MenuItem ${
                  window.location.href.includes(
                    `${match.path}/${routes.ipmLanding}`
                  )
                    ? 'is-active'
                    : ''
                }`}
                onClick={closeSidebar}
                onKeyDown={e => {
                  if (e.keyCode === 13) {
                    closeSidebar(e)
                  }
                }}
              >
                <SVG height={20} width={20}>
                  {ipmSvg}
                </SVG>
                <div className="link-text">
                  <FormattedMessage
                    id="FixedSidebar.inPortManning"
                    defaultMessage="In Port Manning (IPM)"
                  />
                </div>
              </div>
            </Link>
          </div>
        )}

      {shouldShowReportList &&
        get(settings, 'sidebar.shouldShowReportList', false) && (
          <div className="MenuItemContainer">
            <Link to={`${match.path}/${routes.reports}`}>
              <div
                role="button"
                tabIndex={0}
                className={`MenuItem ${
                  window.location.href.includes(routes.reports)
                    ? 'is-active'
                    : ''
                }`}
                onClick={closeSidebar}
                onKeyDown={e => {
                  if (e.keyCode === 13) {
                    closeSidebar(e)
                  }
                }}
              >
                <SVG height={20} width={20}>
                  {reportsSvg}
                </SVG>
                <div className="link-text">
                  <FormattedMessage
                    id="FixedSidebar.reports"
                    defaultMessage="Reports"
                  />
                </div>
              </div>
            </Link>
          </div>
        )}

      {isShore &&
        shouldShowSettings &&
        get(settings, 'sidebar.shouldShowSettingList', false) && (
          <div className="MenuItemContainer">
            <Link to={`${match.path}/${routes.settings}`}>
              <div
                role="button"
                tabIndex={0}
                className={`MenuItem ${
                  window.location.href.includes(routes.settings)
                    ? 'is-active'
                    : ''
                }`}
                onClick={closeSidebar}
                onKeyDown={e => {
                  if (e.keyCode === 13) {
                    closeSidebar(e)
                  }
                }}
              >
                <SVG height={20} width={20}>
                  {settingsSVG}
                </SVG>
                <div className="link-text">
                  <FormattedMessage
                    id="FixedSidebar.settings"
                    defaultMessage="Settings"
                  />
                </div>
              </div>
            </Link>
          </div>
        )}

      {shouldShowVoyagePortTerminals && (
        <div className="MenuItemContainer">
          <Link to={`${match.path}/${routes.portCoordinates}`}>
            <div
              role="button"
              tabIndex={0}
              className={`MenuItem ${
                window.location.href.includes(routes.portCoordinates)
                  ? 'is-active'
                  : ''
              }`}
              onClick={closeSidebar}
              onKeyDown={e => {
                if (e.keyCode === 13) {
                  closeSidebar(e)
                }
              }}
            >
              <SVG height={20} width={20}>
                {coordinateSVG}
              </SVG>
              <div className="link-text">
                <FormattedMessage
                  id="FixedSidebar.portCoordinates"
                  defaultMessage="Port Coordinates"
                />
              </div>
            </div>
          </Link>
        </div>
      )}

      {shouldShowCbpDashboard &&
        get(settings, 'cbpDashboard.shouldShowCbpDashboard', false) && (
          <div className="MenuItemContainer">
            <Link to={`${match.path}/${routes.cbpDashboard}`}>
              <div
                role="button"
                tabIndex={0}
                className={`MenuItem ${
                  window.location.href.includes(routes.cbpDashboard)
                    ? 'is-active'
                    : ''
                }`}
                onClick={closeSidebar}
                onKeyDown={e => {
                  if (e.keyCode === 13) {
                    closeSidebar(e)
                  }
                }}
              >
                <SVG height={20} width={20}>
                  {dashboardSvg}
                </SVG>
                <div className="link-text">
                  <FormattedMessage
                    id="FixedSidebar.cbpDashboard"
                    defaultMessage="CBP Dashboard"
                  />
                </div>
              </div>
            </Link>
          </div>
        )}

      <div className="version MenuItemContainer">
        <div className="MenuItem">
          <div>Version: {pjson.version}</div>
          <input
            type="hidden"
            value={pjson.version}
            className="componentVersion"
          />
        </div>
      </div>
    </div>
  )
}

FixedSidebar.propTypes = {
  closeSidebar: PropTypes.func,
  match: PropTypes.object.isRequired,
  voyageName: PropTypes.string,
  shouldShowAlertList: PropTypes.bool,
  shouldShowMessageList: PropTypes.bool,
  shipName: PropTypes.string,
  isShore: PropTypes.boolean,
  shouldShowBoardingSlots: PropTypes.bool,
  shouldShowBoardingCount: PropTypes.bool,
  shouldShowCrewList: PropTypes.bool,
  shouldShowCrewRolesManagement: PropTypes.bool,
  shouldShowGuestList: PropTypes.bool,
  shouldShowVisitorList: PropTypes.bool,
  shouldShowIPMDutiesList: PropTypes.bool,
  shouldShowSettings: PropTypes.bool,
  shouldShowReportList: PropTypes.bool,
  shouldShowStateroom: PropTypes.bool,
  shouldShowCreateReservation: PropTypes.bool,
  shouldShowMasterTemplate: PropTypes.bool,
  shouldShowVoyagePortTerminals: PropTypes.bool,
  settings: PropTypes.shape({}),
  totalActiveSlotsCount: PropTypes.string,
  latestBoardingSlot: PropTypes.shape({}),
  shouldShowDashboard: PropTypes.bool,
  isShipMode: PropTypes.string,
  shouldShowCbpDashboard: PropTypes.bool
}

FixedSidebar.defaultProps = {
  voyageName: '',
  shipName: '',
  isShore: false,
  closeSidebar: () => {},
  shouldShowAlertList: false,
  shouldShowMessageList: false,
  shouldShowCrewList: false,
  shouldShowBoardingSlots: false,
  shouldShowBoardingCount: false,
  shouldShowGuestList: false,
  shouldShowCrewRolesManagement: false,
  shouldShowVisitorList: false,
  shouldShowIPMDutiesList: false,
  shouldShowSettings: false,
  shouldShowReportList: false,
  shouldShowDashboard: false,
  shouldShowStateroom: false,
  shouldShowCreateReservation: false,
  shouldShowMasterTemplate: false,
  shouldShowVoyagePortTerminals: false,
  shouldShowCbpDashboard: false,
  settings: {}
}

export default withRouter(FixedSidebar)
